import React, { useState, useCallback, memo } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { ControlledTabs } from 'components/Tabs';
import { Loading } from 'components/Loading';
import { placeOrder, placeOrderPriced } from 'redux/actions/orders';
import { LimitOrder, MarketOrder, StopOrder } from 'containers/CreateOrder';
import { withNamespaces } from 'react-i18next';
import { Box, Text } from 'components/Wrapped';
import { TradeModeSwitcher } from './components/TradeModeSwitcher';

const CreateOrder = memo((props) => {
  const { tradingPair, tradingPairStats, extraProps, markets } = props;
  const [tradeMode, setTradeMode] = useState('buy'); // 'sell' | 'buy'
  const maxOrderValue = _.get(markets.prices, `[${tradingPair.quoteCurrency}][${tradingPair.baseCurrency}].maxOrderValue`, 0);

  const onChangeTradeMode = useCallback(
    (mode) => {
      setTradeMode(mode);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tradeMode],
  );

  return tradingPair.baseCurrency ? (
    <Box pad={{ right: '3px' }} height="min-content" overflow={{ vertical: 'auto' }}>
      <Box flex={{ shrink: 0 }} pad={{ vertical: '12px' }}>
        <Text color="white" size="14px" weight={600} style={{ lineHeight: '16px' }}>
          Торговля
        </Text>
      </Box>
      <TradeModeSwitcher tradeMode={tradeMode} onChangeTradeMode={onChangeTradeMode} />
      <ControlledTabs
        containerProps={{
          className: 'is-flex flex-column',
        }}
        renderAllChildren={false}
        // tabContentProps={{
        //   className: 'react-virtualized-container-fix',
        // }}
        tabProps={{
          marginless: true,
          fullwidth: true,
          className: 'top-border-radius',
          pad: { horizontal: '0px', vertical: '8px' },
          ...extraProps?.tabProps,
        }}
        tabItemProps={{
          ...extraProps?.tabItemProps,
        }}
        flexMode={true}
        tabsGap="0"
      >
        <LimitOrder
          // title={t('exchange.limitOrder')}
          title="Лимит"
          tradingPair={tradingPair}
          placeOrder={props.placeOrder}
          tradeMode={tradeMode}
          maxOrderValue={maxOrderValue}
          lastPrice={tradingPairStats.lastPrice}
        />
        <MarketOrder
          // title={t('exchange.marketOrder')}
          title="Маркет"
          tradingPair={tradingPair}
          placeOrder={props.placeOrder}
          placeOrderPriced={props.placeOrderPriced}
          tradeMode={tradeMode}
          maxOrderValue={maxOrderValue}
        />
        <StopOrder
          // title={t('exchange.stopOrder')}
          title="Стоп"
          tradingPair={tradingPair}
          placeOrder={props.placeOrder}
          tradeMode={tradeMode}
          maxOrderValue={maxOrderValue}
        />
      </ControlledTabs>
    </Box>
  ) : (
    <Loading />
  );
});

const mapStateToProps = ({ exchange, markets, exchangeSettings: { settings } }) => ({
  tradingPair: exchange.tradingPair,
  tradingPairSettings: exchange.tradingPairSettings,
  tradingPairStats: exchange.tradingPairStats,
  markets,
  mgokx: settings.mgokx,
});

const mapDispatchToProps = {
  placeOrder,
  placeOrderPriced,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(CreateOrder));
